import { createContext, useContext, useState } from 'react';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  // Initialize the context value with an object containing the necessary state and functions
  const [sharedData, setSharedData] = useState({
    data: {},
    identificationType: null,
    UserType: null,
    RegistrationStatus: null,
    businessRegistrationUri: null,
    select1: null,
    select2: null,
    select3: null,
    position: null,
    profileOptionsValue: null,
    profileUri: null,
    bannerUri: null,
    entityTypeOptionsValue: null,
    activityOptionsValue: null,
    mandatedStatementUri: null,
    userIdInativo:null,
    donationIDEventos: '',
    numberBenef: null,
    ratingEventos: null,
    collectionEventos:[] , 
    motiveEventos: '',
    ratingEventos: null
  });

  

  const contextValue = {
    sharedData,
    setSharedData,

  };

  return <DataContext.Provider value={contextValue}>{children}</DataContext.Provider>;
};

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};